import { Context } from "csi/def/Context";
import declare from "dojo/_base/declare";
import _ from "lodash";
import PathMatrix from "csi/table/matrix/Path";
import { C8Node } from "src/c8-platform/type/node";


const CompositionBySalesRegionMatrix = declare(PathMatrix, {
	addDependencyPaths(h: any, paths: string[]): void {
		// summary: add any dependency paths necessary to process matrix
		paths.push("Child:CareInstructions/Child:LanguageIcons");
		paths.push("Child:CareIcons");
		this.inherited(arguments);
	},

	/**
     * @override
     * Get the Language under the SalesRegion and make sure they're unique
     */
	_getRowNodes(ctx: Context, qr: any, c: any, node?: C8Node): C8Node[] {
		const salesRegion = node ? ctx.cache.getNode(node?.SalesRegion || "") : null;
		const salesRegionSpec = salesRegion
			? ctx.cache.getNode(salesRegion.ProductSalesRegionSpec || "")
			: ctx.cache.getNode(node?.ProductSalesRegionSpec || "");

		let languages: C8Node[] = [];

		if (salesRegionSpec) {
			_.each(salesRegionSpec.SellingCountries, (countryURL: string) => {
				const country = ctx.cache.getNode(countryURL);
				languages = languages.concat(ctx.cache.getNodes(country.Languages || []));
			});
		}

		return _.uniq(languages);
	},
});

export = CompositionBySalesRegionMatrix;